import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { BrowserRouter } from 'react-router-dom';
import { registerSW } from 'virtual:pwa-register';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import './styles/globals.css';

// Registra o Service Worker e recarrega automaticamente quando há atualização
const updateSW = registerSW({
  immediate: true,
  onNeedRefresh() {
    // Nova versão disponível - recarrega automaticamente
    console.log('Nova versão disponível, recarregando...');
    updateSW(true);
  },
  onOfflineReady() {
    console.log('App pronta para uso offline');
  },
  onRegisteredSW(_swUrl, registration) {
    // Verifica atualizações a cada 1 minuto (mais agressivo para ambiente de demo)
    if (registration) {
      setInterval(() => {
        registration.update();
      }, 60 * 1000); // 1 minute
    }
  },
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 30, // 30 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <ToastProvider>
            <App />
          </ToastProvider>
        </AuthProvider>
      </BrowserRouter>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </React.StrictMode>
);
